let buttons_open = document.querySelectorAll(".btn_open");
function openModal(name) {
    let modal_form = document.querySelector(name);
    let close = modal_form.getElementsByClassName("close_modal_window")[0];

    modal_form.classList.add('open');

    close.onclick = function () {
        modal_form.classList.remove('open');
    }

    window.onclick = function (event) {
        if (event.target == modal_form) {
            modal_form.classList.remove('open');
        }
    }
}

buttons_open.forEach((btn) => {
    btn.addEventListener('click', function () {
        openModal(".modal_form");
    });

});

document.querySelector('body').addEventListener('mouseleave', function () {
    if (document.cookie.replace(/(?:(?:^|.*;\s*)doSomethingOnlyOnce\s*\=\s*([^;]*).*$)|^.*$/, "$1") !== "true") {
        openModal(".modal_leave");
        let cookie_date = new Date ();
        cookie_date.setDate(cookie_date.getDate() + 1);
        document.cookie = "doSomethingOnlyOnce=true; expires="+cookie_date.toGMTString()+"";
    }
});


// buttons_open1.forEach((btn) => {
//     btn.addEventListener('click', function (e) {
//         openModal(".modal_thanks");
//     });
// });

